<template>
<div class="no-precio">
    <h3><b>No disponemos del precio de esta planta.</b></h3>
    <h4 class="mb-3">Pero podemos ayudarte</h4>
    <b>Si lo necesitas, puedes comprar otra variedad</b><br>
    (Babyplant Selección siempre disponible)
    <b-button class="btn mt-3 mb-4" variant="outline-light" @click="$emit('choose-other-variety')">
        Escoger otra variedad
    </b-button>
    <div v-if="!formSent">
        <p>
            Puedes rellenar el formulario y se nos notificará la variedad de la que no podemos mostrar el precio para darte
            una solución lo antes posible.
        </p>
        <div class="form-group">
            <input type="text" class="form-control" placeholder="Nombre" aria-label="Nombre" v-model="form.nombre"
                   :class="((errors['nombre']) ? 'is-invalid' : '')">
        </div>
        <div class="form-group">
            <input type="text" class="form-control" placeholder="Móvil" aria-label="Móvil" v-model="form.movil"
                   :class="((errors['movil']) ? 'is-invalid' : '')">
        </div>
        <div class="form-group">
            <input type="email" class="form-control" placeholder="Correo electrónico" aria-label="Correo electrónico"
                   v-model="form.email" :class="((errors['email']) ? 'is-invalid' : '')">
        </div>
        <p style="font-size: 0.8rem">
            Al enviar el formulario aceptas los
            <a class="no-precio-link" :href="route('info.terminos.condiciones')">terminos y condiciones</a>
            y la <a class="no-precio-link" :href="route('info.politica.privacidad')">política de privacidad</a>.
        </p>
        <b-button class="btn mt-3" variant="outline-light" @click="submit" :disabled="loading">
            Enviar
        </b-button>
    </div>
    <div v-else>
        <h3>¡Gracias!</h3>
    </div>
</div>
</template>

<script>
export default {
    name: "NoPrice",
    data() {
        return {
            form: {
                nombre: "",
                movil: "",
                semana: "",
                producto: "",
                type: "no_price",
                email: "",
                mensaje: "Variedad sin precio"
            },
            formSent: false,
            loading: false,
            errors: []
        }
    },
    computed: {
        producto() {
            let producto = "";
            let variety = this.$store.state.custom.varietySelected;
            let varietyPie = this.$store.state.custom.varietyPieSelected;
            if (variety) {
                producto = variety.mote.especie.nombre + ' ' + variety.mote.nombre + ' ' + variety.nombre;
                if (varietyPie) {
                    producto += ' injertado en ' + varietyPie.mote.especie.nombre + ' ' + varietyPie.mote.nombre + ' ' + varietyPie.nombre;
                }
            }
            return producto;
        }
    },
    watch: {
        producto(newVal) {
            this.form.producto = newVal;
        }
    },
    methods: {
        submit() {
            this.loading = true;

            axios.post(this.route('send.contact'), this.form).then(response => {
                this.errors = [];
                this.formSent = true;
                Vue.toasted.show(response.data.info, {
                    type: "success",
                    duration: 3000
                });

                this.form = {nombre: "", movil: "", email: ""};
            }).catch(e => {
                this.errors = e.response.data.errors;

                Vue.toasted.show(e.response.data.info ? e.response.data.info : 'Ha habido un error', {
                    type: "error",
                    duration: 3000
                });

                console.log(e);
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    created() {
        this.form.producto = this.producto;
    }
}
</script>

<style scoped>
    .no-precio {
        background-color: #c22830;
        color: #ffffff;
        text-align: center;
        padding: 1.5rem;
        border-radius: 8px;
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
    }

    .no-precio input {
        border-radius: 0;
        font-weight: bold;
    }

    .btn {
        display: block;
        margin: auto;
        font-weight: bold;
        border-width: 0.15em;
        width: 100%;
        max-width: 260px;
    }

    .no-precio-link {
        color: #ffffff;
        text-decoration: underline;
    }


</style>
